// src/pages/contacts/ContactsPage.jsx
import React from "react";
import ContactsHero from "./ContactsHero";
import ContactSection from "./ContactSection";
import Footer from "../Footer";

import Reveal from "../../components/Reveal"; // ⬅️ перевір шлях

export default function ContactsPage() {
  return (
    <div className="contacts-page">
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
  <ContactsHero />
</Reveal>

      {/* Блок із контактами плавно підʼїжджає знизу */}
      <Reveal as="section" variant="up">
        <ContactSection />
      </Reveal>

      {/* Footer з fade-ефектом */}
      <Reveal as="footer" variant="fade" delay={0.08}>
        <Footer />
      </Reveal>
    </div>
  );
}
